<div class="scrollable">
    <panel [noButton]="true">
        <h5>Editar o Crear Entidad</h5>
        <div class="row" [formGroup]="entityForm">
            <div class="col-md-6 col-xl-4 my-2">
                Código:
                <input type="text" class="form-control" formControlName="code">
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Nombre:
                <input type="text" class="form-control" formControlName="name">
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Grupo:
                <ng-select [items]="groups" formControlName="groupId" bindLabel="name" bindValue="id"
                    [compareWith]="compareById" placeholder="Seleccione un grupo"></ng-select>
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Campo:
                <ng-select [items]="offices" formControlName="officeId" bindLabel="acronym" bindValue="id"
                    [compareWith]="compareById" placeholder="Seleccione un campo"></ng-select>
            </div>
            @if(modulesForGroup.length > 0){
            <div class="col-12 my-2">
                <div class="alert alert-info py-2 mb-2">
                    <i class="fas fa-users me-1"></i>
                    Grupo con {{modulesForGroup.length}} módulo(s) — asigne un auditor por módulo.
                </div>
            </div>
            @for(mod of modulesForGroup; track mod.id){
            <div class="col-md-6 col-xl-4 my-2">
                Auditor — {{mod.name}} ({{mod.acronym}}):
                <ng-select [items]="auditors" bindLabel="displayName" bindValue="id"
                    [(ngModel)]="auditorsByModule[mod.id]" [ngModelOptions]="{standalone: true}"
                    [clearable]="true" placeholder="Sin auditor asignado"></ng-select>
            </div>
            }
            } @else if(entityForm.get('groupId')?.value) {
            <div class="col-12 my-2">
                <div class="alert alert-warning py-2">
                    <i class="fas fa-triangle-exclamation me-1"></i>
                    El grupo seleccionado no tiene módulos asociados. Asigne el grupo en <b>Administración → Módulos</b>.
                </div>
            </div>
            }
        </div>
        <div class="modal-footer mt-5">
            <button class="btn btn-danger btn-xs mx-1" (click)="cancel()">Cancelar</button>
            <button class="btn btn-primary btn-xs mx-1" (click)="save()">Guardar</button>
        </div>


    </panel>
</div>